import { render, staticRenderFns } from "./drawer-role-detail.vue?vue&type=template&id=93b254de&scoped=true&"
import script from "./drawer-role-detail.vue?vue&type=script&lang=js&"
export * from "./drawer-role-detail.vue?vue&type=script&lang=js&"
import style0 from "./drawer-role-detail.vue?vue&type=style&index=0&id=93b254de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b254de",
  null
  
)

export default component.exports